export const isValidInviteEmail = (email) => {
  if (typeof email !== 'string') return false;

  const value = email.trim();
  if (value.length === 0 || value.length > 254) return false;

  const at = value.indexOf('@');
  if (at <= 0 || at !== value.lastIndexOf('@') || at === value.length - 1) return false;

  const local = value.slice(0, at);
  const domain = value.slice(at + 1);

  if (local.length > 64 || domain.length > 253) return false;
  if (domain.includes('..')) return false;

  const isAlphaNum = (c) => (c >= '0' && c <= '9') || (c >= 'A' && c <= 'Z') || (c >= 'a' && c <= 'z');
  const localAllowed = new Set("!#$%&'*+/=?^_`{|}~-.");

  if (local.startsWith('.') || local.endsWith('.')) return false;
  for (let i = 0; i < local.length; i += 1) {
    const ch = local[i];
    if (!(isAlphaNum(ch) || localAllowed.has(ch))) return false;
    if (ch === '.' && local[i + 1] === '.') return false;
  }

  const labels = domain.split('.');
  if (labels.length < 2) return false;

  return labels.every(
    (label) =>
      label.length > 0 &&
      label.length <= 63 &&
      !label.startsWith('-') &&
      !label.endsWith('-') &&
      [...label].every((ch) => isAlphaNum(ch) || ch === '-')
  ) && labels[labels.length - 1].length >= 2;
};

export const getInvitePeopleValidationState = ({ email = '', role = '', isLoading = false } = {}) => {
  const emailValue = typeof email === 'string' ? email.trim() : '';
  const roleValue = typeof role === 'string' ? role.trim() : role;
  const emailError = !emailValue ? 'Email is required' : isValidInviteEmail(emailValue) ? '' : 'Invalid email format';
  const roleError = roleValue ? '' : 'Role is required';
  const isFormValid = !emailError && !roleError;
  const reasons = [emailError, roleError].filter(Boolean);

  return {
    emailError,
    roleError,
    isEmailValid: !emailError,
    isFormValid,
    submitDisabled: isLoading || !isFormValid,
    submitHelperText: !isLoading && reasons.length ? `Submit is disabled: ${reasons.join('. ')}.` : '',
    emailHelperText: emailError || 'Email is valid.',
    roleHelperText: emailError ? 'Enter a valid email before choosing a role.' : roleError || '',
  };
};
